if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        if (this.querySelector("product-selling-plans")) {
          this.planSelectors = Array.from(
            this.querySelectorAll('input[type="radio"]')
          );
          this.sellingPlanInput = this.querySelector(
            'input[name="selling_plan"]'
          );
          // Check if plan change
          this.planSelectors.forEach((radio) => {
            radio.addEventListener(
              "change",
              this.listenToSellingPlanChange.bind(this)
            );
          });
        }
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        // Check if Abos in Cart
        if (document.querySelector("#js_abo_container")) {
          const currentSubscriptionPlan = document
            .querySelector("#js_abo_container")
            .querySelector('mcp-radio-select input[type="radio"]:checked');
          this.setInputPlanId(currentSubscriptionPlan.value);
        }

        // Put selling plan to null if onetime
        if (
          this.querySelector('input[type="radio"]:checked')?.dataset
            .radioType === "one_time_purchase" &&
          this.sellingPlanInput
        ) {
          this.sellingPlanInput.value = null;
        }

        // Update selling plan input on plan change in cart
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (event.source === "radio-select") {
              //console.log("event.currentPlan", event.currentPlan);
              this.setInputPlanId(event.currentPlan);
            }
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      setInputPlanId(currentPlan) {
        if (
          !document.querySelector(
            'script[type="application/ld+json"]#productSellingPlans'
          )
        )
          return;
        // Get selling plan from json
        let productPlans = JSON.parse(
          document.querySelector(
            'script[type="application/ld+json"]#productSellingPlans'
          ).innerHTML
        );
        let selectedPlan = productPlans.selling_plans.find(
          (sellingPlan) => sellingPlan.name === currentPlan
        );
        //console.log("productPlans", productPlans);
        //console.log("selectedPlan", selectedPlan);
        //console.log("this.sellingPlanInput", this.sellingPlanInput);
        if (currentPlan && this.sellingPlanInput) {
          this.sellingPlanInput.value = selectedPlan.id;
        }
      }

      listenToSellingPlanChange(event) {
        //console.log("CHANGE", event.target);
        if (!event.target) return;

        /*console.log("this.planSelectors", this.planSelectors);
        console.log(
          "event.target.dataset.radioType",
          event.target.dataset.radioType
        );*/

        // If Subscription --> change button wording (TODO)
        if (event.target.dataset.radioType === "selling_plan") {
          this.toggleSubmitButton(
            this.submitButton?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
            true
          );
          if (document.querySelector("#js_abo_container")) {
            // Get plan from cart
            const currentSubscriptionPlan = document
              .querySelector("#js_abo_container")
              .querySelector('mcp-radio-select input[type="radio"]:checked');
            //console.log("currentSubscriptionPlan", currentSubscriptionPlan);
            this.setInputPlanId(currentSubscriptionPlan.value);
          } else {
            //console.log("sellingPlanId", event.target.dataset.sellingPlanId);
            this.sellingPlanInput.value = event.target.dataset.sellingPlanId;
          }
        } else {
          // One time
          this.toggleSubmitButton(
            this.submitButton?.hasAttribute("disabled") ?? true,
            window.variantStrings.soldOut,
            false
          );
          this.sellingPlanInput.value = null;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        /*if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }*/
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            /*const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            */
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }); /*.then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });*/
            this.error = false;

            /*const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }*/
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              setTimeout(() => {
                quickAddModal.hide(true);
              }, "200");
            }
            //CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, subscription = false) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          subscription
            ? (this.submitButtonText.textContent =
                window.variantStrings.addSubscriptionToCart)
            : (this.submitButtonText.textContent =
                window.variantStrings.addToCart);
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
